import { createAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import ApplicationMetadataApi from 'api/ApplicationMetadataApi';
import * as dto from 'client/dto';

import { loadMetadataError, loadMetadataStart, loadMetadataSuccess } from './metadata.slice';

export const fetchMetadata = createAction('metadata/fetchMetadata');

export function* fetchMetadataSaga() {
  try {
    yield put(loadMetadataStart());
    const response: dto.ApplicationMetadataModel = yield call(ApplicationMetadataApi.getMetadata);
    yield put(loadMetadataSuccess(response));
  } catch (e) {
    yield put(loadMetadataError);
  }
}

function* metadataSaga() {
  yield takeLatest(fetchMetadata, fetchMetadataSaga);
}

export default metadataSaga;
